import { Link } from 'react-router-dom';

interface Category {
  id: number;
  name: string;
  icon_url?: string;
  description?: string;
  product_count?: number;
}

interface CategoryCardProps {
  category: Category;
}

const CategoryCard = ({ category }: CategoryCardProps) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getGradientColor = (id: number) => {
    const colors = [
      'from-blue-500 to-blue-600',
      'from-purple-500 to-purple-600',
      'from-green-500 to-green-600',
      'from-orange-500 to-orange-600',
      'from-pink-500 to-pink-600',
      'from-teal-500 to-teal-600',
      'from-indigo-500 to-indigo-600',
      'from-red-500 to-red-600',
    ];
    return colors[id % colors.length];
  };

  return (
    <Link
      to={`/products?category=${category.id}`}
      className="group bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer"
    >
      {/* Icon/Logo */}
      <div className="mb-4 flex items-center justify-center">
        {category.icon_url ? (
          <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-100">
            <img
              src={category.icon_url}
              alt={category.name}
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          <div
            className={`w-16 h-16 rounded-full bg-gradient-to-br ${getGradientColor(
              category.id
            )} flex items-center justify-center text-white text-xl font-bold`}
          >
            {getInitials(category.name)}
          </div>
        )}
      </div>

      {/* Category Name */}
      <h3 className="text-lg font-bold text-gray-900 mb-2 text-center group-hover:text-blue-600 transition-colors line-clamp-2">
        {category.name}
      </h3>

      {/* Product Count */}
      <p className="text-sm text-gray-600 text-center mb-4">
        {category.product_count || 0} product{category.product_count !== 1 ? 's' : ''}
      </p>

      {/* View Products Button */}
      <div className="flex items-center justify-center gap-2 text-blue-600 group-hover:text-blue-700 transition-colors">
        <span className="text-sm font-medium">View Products</span>
        <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform w-5 h-5 flex items-center justify-center"></i>
      </div>
    </Link>
  );
};

export default CategoryCard;
